<!-- eslint-disable vue/singleline-html-element-content-newline -->
<template>
  <form @submit.prevent="$emit('submit')">
    <div class="-mb-8 -mr-6 flex flex-wrap p-8">
      <h4 class="text-1xl font-bold w-full pb-4">Идентификация</h4>

      <text-input
        v-model="form.setting.yookassa_shop_id"
        :errors="form.errors.yookassa_shop_id"
        class="w-full pb-8 pr-6 lg:w-1/2"
        label="Shop ID"
      />
      <text-input
        v-model="form.setting.yookassa_client_application_key"
        :errors="form.errors.yookassa_client_application_key"
        class="w-full pb-8 pr-6 lg:w-1/2"
        label="Client Application Key"
      />
      <text-input
        v-model="form.setting.yookassa_client_secret"
        :errors="form.errors.yookassa_client_secret"
        class="w-full pb-8 pr-6"
        label="Client Secret"
      />

      <h4 class="text-1xl font-bold w-full pb-4 pt-2">Параметры API</h4>

      <text-input
        v-model="form.setting.yookassa_api_url"
        :errors="form.errors.yookassa_api_url"
        class="w-full pb-8 pr-6 lg:w-1/2"
        label="URL API"
      />
      <text-input
        v-model="form.setting.yookassa_vat_code"
        :errors="form.errors.yookassa_vat_code"
        class="w-full pb-8 pr-6 lg:w-1/2"
        label="Код НДС (vat_code)"
        type="number"
        min="1"
        step="1"
      />

      <h4 class="text-1xl font-bold w-full pb-4 pt-2">Шаблон описания</h4>

      <text-input
        v-model="form.setting.yookassa_description_template"
        :errors="form.errors.yookassa_description_template"
        class="w-full pb-8 pr-6"
        label="Шаблон описания позиции чека"
      />
      <p class="w-full text-sm text-gray-500 -mt-4 pb-4 pr-6">
        Доступная переменная: <code>{order_number}</code>
      </p>
    </div>

    <slot />
  </form>
</template>

<script>
import TextInput from '@/Shared/TextInput.vue';

export default {
  components: {
    TextInput,
  },
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
  },
  emits: ['update:modelValue', 'submit'],
  computed: {
    form: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>
